import axios from 'axios';

const getAllowedChildren = (distributorId) => {
  return axios.get(`/merchant/${distributorId}/allowed-children`);
};


export default {
  getAllowedChildren,
};